import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import CustomCard from "../../../../../dentail-indetifcation/components/d-reusable/CustomCard";

const AgeAssessmentBarChart = ({ data }) => {
  // Array to map month numbers to month names and their abbreviations
  // Array to map month numbers to month names
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Get the current month and year
  const currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1; // JS months are 0-based
  let currentYear = currentDate.getFullYear();

  // Get last 6 months dynamically
  const recentMonths = [];
  for (let i = 5; i >= 0; i--) {
    let monthIndex = (currentMonth - i - 1 + 12) % 12; // To handle wrap-around
    let year = currentMonth - i - 1 < 0 ? currentYear - 1 : currentYear;
    let monthName = months[monthIndex];

    // Format month as "MM YYYY" to match dataset keys
    let formattedMonth = `${(monthIndex + 1)
      .toString()
      .padStart(2, "0")} ${year}`;

    // Find matching entry in data
    let matchingEntry = data.find((entry) => entry.month === formattedMonth);

    recentMonths.push({
      name: `${monthName} ${year}`, // Show "Jan 2024"
      count: matchingEntry ? matchingEntry.count : 0, // Use 0 if no data available
    });
  }
  return (
    <CustomCard>
      <div className="chart_card_container">
        <h6>No. of Cases</h6>
        <p>Last 6 Months</p>
      </div>
      <div style={{ width: "100%", height: 330 }}>
        <ResponsiveContainer>
          <BarChart data={recentMonths}>
            <CartesianGrid
              strokeDasharray="3 3"
              horizontal={true}
              vertical={false}
            />
            <XAxis dataKey="name" axisLine={false} tickLine={false} />
            <YAxis axisLine={false} tickLine={false} />
            {/* <Tooltip /> */}
            <Bar dataKey="count" fill="#50F5AE" barSize={30} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </CustomCard>
  );
};

export default AgeAssessmentBarChart;
